
import { Card, Table, Button, Form, InputGroup } from 'react-bootstrap';
import { FaListAlt, FaPlus, FaTrash } from 'react-icons/fa';
import { colors } from '../../../../utils/Colors';

const MenuCard = ({ 
  menu, 
  foodBillBreakdown, 
  formatCurrency, 
  onAddClick, 
  onRemoveItem, 
  onUpdateItem 
}) => {
  return (
    <Card className="border-0 shadow-sm mb-4">
      <Card.Header className="bg-white border-0 py-3 d-flex justify-content-between align-items-center">
        <h5 className="mb-0 fw-bold">
          <FaListAlt className="me-2" />
          Menu Items ({menu.length})
        </h5>
        <div>
          <Button variant="primary" size="sm" onClick={onAddClick}>
            <FaPlus className="me-1" />
            Add Item
          </Button>
        </div>
      </Card.Header>
      <Card.Body>
        <div className="table-responsive">
          <Table hover size="sm">
            <thead>
              <tr>
                <th style={{ backgroundColor: colors.TABLE_HEADERS, color: '#fff', width: '5%' }}>#</th>
                <th style={{ backgroundColor: colors.TABLE_HEADERS, color: '#fff', width: '65%' }}>Item Name</th>
                <th style={{ backgroundColor: colors.TABLE_HEADERS, color: '#fff', width: '20%' }}>Price</th>
                <th style={{ backgroundColor: colors.TABLE_HEADERS, color: '#fff', width: '10%' }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {menu.map((item, index) => (
                <tr key={item._id || index}>
                  <td>{index + 1}</td>
                  <td>
                    <Form.Control
                      type="text"
                      value={item.item}
                      onChange={(e) => onUpdateItem(index, 'item', e.target.value)}
                      size="sm"
                    />
                  </td>
                  <td>
                    <InputGroup size="sm">
                      <InputGroup.Text>Rs</InputGroup.Text>
                      <Form.Control
                        type="number"
                        value={item.price}
                        onChange={(e) => onUpdateItem(index, 'price', e.target.value)}
                        min="0"
                      />
                    </InputGroup>
                  </td>
                  <td>
                    <Button
                      variant="outline-danger"
                      size="sm"
                      onClick={() => onRemoveItem(index)}
                      title="Remove item"
                    >
                      <FaTrash />
                    </Button>
                  </td>
                </tr>
              ))}
              {menu.length === 0 && (
                <tr>
                  <td colSpan="4" className="text-center text-muted py-3">
                    No menu items. Click "Add Item" to add menu items.
                  </td>
                </tr>
              )}
            </tbody>
            {menu.length > 0 && (
              <tfoot>
                <tr>
                  <td colSpan="2" className="text-end fw-bold">Total Menu Items:</td>
                  <td className="fw-bold">
                    {formatCurrency(foodBillBreakdown.menuTotal)}
                  </td>
                  <td></td>
                </tr>
              </tfoot>
            )}
          </Table>
        </div>
        <div className="mt-3 small text-muted bg-light p-2 rounded">
          <strong>Food Bill Calculation:</strong><br />
          • Per Head: {formatCurrency(foodBillBreakdown.perHead)}<br />
          • Persons: {foodBillBreakdown.persons}<br />
          • Base Food Bill: {formatCurrency(foodBillBreakdown.perHead)} × {foodBillBreakdown.persons} = {formatCurrency(foodBillBreakdown.baseFoodBill)}<br />
          • Menu Items Total: {formatCurrency(foodBillBreakdown.menuTotal)}<br />
          • Total Food Bill: {formatCurrency(foodBillBreakdown.baseFoodBill)} + {formatCurrency(foodBillBreakdown.menuTotal)} = {formatCurrency(foodBillBreakdown.totalFoodBill)}
        </div>
      </Card.Body>
    </Card>
  );
};

export default MenuCard;